import {
    SimpleForm,
    TextInput
} from "react-admin";

export function QuizAssessmentQuestionBankForm(props) {

    return (
        <SimpleForm
            redirect={'list'}
            {...props}
        >
            <TextInput source='name' label='Nome' fullWidth required />
            <TextInput source="description" label="Descrição" multiline minRows={2} fullWidth />

        </SimpleForm>
    )
}
